import { MvcSearch } from '../interfaces/Mvc'
import getUrlParameters from '../utils/getUrlParameters';
import { getUrlMvmApi } from '../utils/util';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlMvmApi(window));

export default class MvcApi {

    static async getMvc(mvcId: number) {
        var response = await ApiHandler(baseURL).get(`mvc?id=${mvcId}`);
        return response.data;
    }

    static async search(params: MvcSearch) {
        var response = await ApiHandler(baseURL).get('Mvc/search',  { params: getUrlParameters(params) });
        return response.data;
    }

    static async getDriverData(shippingCompanySupplierId: number, companyId: number, quantity: number) {
        var response = await ApiHandler(baseURL).get(`Mvc/drivers-from-shipping-company?shippingCompanySupplierId=${shippingCompanySupplierId}&companyId=${companyId}&quantity=${quantity}`);
        return response.data;
    }

    static async validateInvoicesInUse(data: any) {
        await ApiHandler(baseURL).post(`Mvc/validate-invoices-in-use`, data);
    }

    static async getInvoiceData(mvcId: number, companyId: number, plantId: string, invoiceKey: string) {
        var response = await ApiHandler(baseURL).get(`Mvc/get-invoice-data?mvcId=${mvcId}&companyId=${companyId}&plantId=${plantId}&key=${invoiceKey}`);
        return response;
    }

    static async postMvc(data: any) {
        var response = await ApiHandler(baseURL).post('mvc', data);
        return response;
    }

    static async putMvc(data: any) {
        var response = await ApiHandler(baseURL).put('mvc', data);
        return response;
    }

    static async receiveMvc(data: any) {
        var response = await ApiHandler(baseURL).put('mvc/receive', data);
        return response;
    }

    static async cancelMvc(data: any) {
        var response = await ApiHandler(baseURL).put('mvc/cancel', data);
        return response;
    }

    static async saveAccountingPendingUserResolution(mvcId: number) {
        var response = await ApiHandler(baseURL).post('mvc/save-accounting-pending-user-resolution?mvcId=' + mvcId);
        return response;
    }
}
